import { generateUtilityClass, generateUtilityClasses } from '@mui/core';
export function getDividerUtilityClass(slot) {
    return generateUtilityClass('FuiDialog', slot);
}
var dialogClasses = generateUtilityClasses('FuiDialog', [
    'root',
    'header',
    'content',
    'footer',
]);
export default dialogClasses;
